<template>
  <SignUpComponent />
</template>
  
  <script>
  import SignUpComponent from '@/components/auth/SignUpComponent.vue';
  
  export default {
    name: 'SignupView',
    components: {
      SignUpComponent,
    },
    mounted() {
    window.scrollTo(0, 0);
    },
  }
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  